import { mediaCards } from '@/mocks/homeData';

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            漫评与推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            编辑团队精心制作，从新番速递到深度漫评，帮你快速发现好漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaCards.slice(0, 3).map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-colors duration-200"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {mediaCards.slice(3).map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group flex flex-col sm:flex-row rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-colors duration-200"
            >
              <div className="relative w-full sm:w-48 aspect-video sm:aspect-auto flex-shrink-0 overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col justify-center">
                <h3 className="text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}